import React from 'react';
import './FeatureCard.css';

const FeatureCard = ({ icon, title, subtitle }) => {
  return (
    <div className="feature-card">
      <div className="feature-icon-circle">
        <img src={icon} alt={title} className="feature-icon-img" />
      </div>
      <div className="feature-text">
        <h4 className="feature-title">{title}</h4>
        <p className="feature-subtitle">{subtitle}</p>
      </div>
    </div>
  );
};

export default FeatureCard;